import { render, staticRenderFns } from "./totaltest.vue?vue&type=template&id=73cd09a8&scoped=true"
import script from "./totaltest.vue?vue&type=script&lang=js"
export * from "./totaltest.vue?vue&type=script&lang=js"
import style0 from "./totaltest.vue?vue&type=style&index=0&id=73cd09a8&prod&lang=scss&scoped=true"
import style1 from "./totaltest.vue?vue&type=style&index=1&id=73cd09a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cd09a8",
  null
  
)

export default component.exports